import { toast } from "sonner";

/**
 * Extract the backend error message (`response.data.result.msg`) from an
 * unknown mutation error and surface it as a toast, falling back to
 * `defaultMsg` when the shape doesn't match.
 */
export const showMutationError = (err: unknown, defaultMsg: string) => {
	const message =
		err && typeof err === "object" && "response" in err
			? (
					err as {
						response?: { data?: { result?: { msg?: string } } };
					}
				).response?.data?.result?.msg
			: undefined;
	toast.error(message ?? defaultMsg);
};
